import { useState, useEffect, useRef } from "react";
import * as axios from "axios";
import { ArticleExtraData } from "../../../../../../articlePage/stateInterfaces";
import { addAxiosDateTransformerSettings } from "../../../../../../utils/network/axiosDateTransformer";
import { ItemJsonVer2 } from "../../../../../jsonSerializer/widgetJsonInterfacesVer2";
import { mapItemJsonToArticleExtraData } from "../../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/utils/newsFlashUtils";
import { NewsFlashSpecialDesktopPopup } from "../../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/desktop/newsFlashSpecialDesktopPopup";
import { isWcmEditor } from "../../../../../../config/serverConfig";
import { LinkTargetProperties } from "../../../../../../global/components/linkSettings/interfaces";
require("./ynet_site_headerFlashBell.less");

interface HeaderFlashBellProps {
    languageCode: string
    flashPageLink: string
    flashLinkTarget: LinkTargetProperties
}

const POLL_INTERVAL = 60000;
const BELL_ANIMATION_DURATION = 3000;
const POPUP_VISIBLE_ITEMS = 100;

export const HeaderFlashBell = (props: HeaderFlashBellProps) => {
    if (typeof window !== "undefined" && (window as any).disableFlashBell) {
        return null;
    }

    const { flashPageLink, flashLinkTarget, languageCode } = props;
    const [itemList, setItemList] = useState<ArticleExtraData[]>([]);
    const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
    const [hasNewFlash, setHasNewFlash] = useState<boolean>(false);
    const [bellPhase, setBellPhase] = useState<"static" | "animated">("animated");
    const [highlightedArticleId, setHighlightedArticleId] = useState<string | null>(null);
    const previousFirstIdRef: any = useRef<string | null>(null);
    const bellTimerRef: any = useRef<ReturnType<typeof setTimeout> | null>(null);
    const popupRef: any = useRef(null);


    const triggerBellAnimation = () => {
        if (bellTimerRef.current) {
            clearTimeout(bellTimerRef.current);
        }
        setBellPhase("animated");
        bellTimerRef.current = setTimeout(() => {
            setBellPhase("static");
        }, BELL_ANIMATION_DURATION);
    };

    const handleOpenPopup = () => {
        if (isWcmEditor()) return;

        if (popupRef.current) {
            popupRef.current.openPopup();
        }
        
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.style.overflow = "hidden";
        setHighlightedArticleId(null);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        document.body.style.paddingRight = "";
        document.body.style.overflow = "";
        setIsPopupOpen(false);
    };

    return (
        <a className="header-flash-bell-wrapper" href={flashPageLink}>
            <div className="header-flash-bell" >
                {bellPhase === "animated" ?
                    <video className="bell-animation-video" src="https://www.ynet.co.il/images/picsrv/Bell-Notification-30x30.webm" autoPlay muted playsInline />
                    :
                    <div className="bell-static-icon"></div>
                }
            </div>
        </a>
    );
};
